import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import TrialSettingsHistoryTable from '../components/trialSettingsHistoryTable';

class TrialSettingsHistoryDialog extends EditingDataHistoryDialog {
	get dataId() {
		return this.props.id;
	}

	get Title() {
		return 'Trial settings history';
	}

	renderTable(tableProps) {
		return <TrialSettingsHistoryTable {...tableProps} />;
	}

	renderBeforeContent() {}

	getLoaderMessage() {
		return 'Tria settings history loading...';
	}
}

const mapStateToProps = (state) => ({
	objectState: objectHistorySelectors.trialSettings(state),
	getEditedFields: () => objectHistorySelectors.trialSettingsEditedFields(state),
});

const actionCreators = {
	fetchHistory: (trialSettingsId) =>
		objectHistory.fetchHistory(trialSettingsId, objectHistoryNames.trialSettings),
	showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(TrialSettingsHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/trialSettingsHistoryDialog.js